import { render, staticRenderFns } from "./Pill.vue?vue&type=template&id=51672523&scoped=true&lang=pug&"
import script from "./Pill.vue?vue&type=script&lang=js&"
export * from "./Pill.vue?vue&type=script&lang=js&"
import style0 from "./Pill.vue?vue&type=style&index=0&id=51672523&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51672523",
  null
  
)

export default component.exports